/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Field_InvalidInputs */

const es_co2_error_field_invalid = /** @type {(inputs: Error_Field_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El valor ingresado no es válido.`)
};

/**

* @param {Error_Field_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_field_invalid = /** @type {((inputs?: Error_Field_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Field_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_field_invalid(inputs)
});